// Config del Tablero de Retrospectiva (spec 006, Incremento 2 — D8-3/RF-29). Flag de front, reversible,
// para apagar toda la UI de votos (dot voting) dejando el like como única señal, sin tocar BD/API/Redux/
// service de voto (siguen existiendo intactos: SP_RETRO_VOTO_AGREGAR/QUITAR, redux/retroBoard
// addRetroVote/removeRetroVote, services/retroBoard.js addVote/removeVote). Reactivar = poner en `true`.
export const RETRO_VOTES_ENABLED = false;
